import React from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import sendContactForm from './actions';
import { sessionSelector } from '../Session/Session.redux';


export default function Sendgrid(Component) {
  class Child extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        value: 'i am value',
      };
    }
    render() {
            // here you can pass down whatever you want 'inherited' by the child
      return <Component {...this.props} {...this.state} />;
    }

    }

  return connect(
      sessionSelector,
    {
      sendContactForm,
    })(Child);
}



// WEBPACK FOOTER //
// ./src/components/SendGrid/Sendgrid.js